<template>
  <div>
    <!-- Third parties table -->
    <div v-if="isGranted([permissions.SYSTEM_THIRD_PARTY_VIEW, permissions.SYSTEM_THIRD_PARTY_VIEW_OWN], system)"
         class="card"
         qid="third-parties-section"
         id="update_third_parties"
    >
      <div class="card-body" :class="{'pr-0 pl-0': showOnTask}">
        <div class="row">
          <div class="col-sm-6">
            <h5 qid="tp-table-title" class="mb-2" v-if="!showOnTask">
              {{ $t('systems.third_parties.title') }}
            </h5>

            <span v-if="!showOnTask">
              <span class="cursor-pointer task-label-open mr-2"
                    v-if="getTask('update_third_parties')"
              >
                <UpdateSingleTaskModal
                    :task="getTask('update_third_parties')"
                    @reloadContent="reloadContent"
                    :editIcon="true"
                ></UpdateSingleTaskModal>
              </span>
              <span v-if="getGuide('update_third_parties')">
                <GuideButton :guide="getGuide('update_third_parties')"></GuideButton>
              </span>
            </span>
          </div>
          <div class="col-sm-6 text-right">
            <span class="btn btn-success ml-3 pl-3 pr-3 cursor-pointer"
                  @click="showCreateTPModal"
                  qid="tp-create-button"
                  v-if="isGranted([permissions.SYSTEM_THIRD_PARTY_CREATE, permissions.SYSTEM_THIRD_PARTY_CREATE_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
            >
              <font-awesome-icon icon="plus"/> {{ $t('systems.policies.create_button') }}
            </span>
          </div>
        </div>

        <table class="table table-responsive-md table-list-secondary">
          <thead>
          <tr>
            <th scope="col">
              {{ $t('systems.third_parties.table.name') }}
            </th>
            <th scope="col">
              {{ $t('systems.third_parties.table.processing_role') }}
            </th>
            <th scope="col">
              {{ $t('table.category') }}
            </th>
            <th scope="col">
              {{ $t('systems.third_parties.table.inspection') }}
            </th>
            <th scope="col">
              {{ $t('systems.third_parties.table.dpa') }}
            </th>
            <th scope="col" class="text-center">
              {{ $t('systems.third_parties.table.validation') }}
            </th>
            <th scope="col">
              {{ $t('system.last_updated') }}
            </th>
            <th width="200"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="object in tpTableItems">
            <td scope="row">
              <span class="cursor-pointer mr-2 mt-2 float-left" @click="openViewVendorModal(object.third_party.vendors[0])">
                <Avatar :object="object.third_party.vendors[0]" size="xs"></Avatar>
              </span>

              <span v-if="object.third_party && object.third_party.name && !isOwner(object.third_party)"
                    qid="system-name"
              >
                {{ object.third_party.name }}
              </span>
              <router-link
                  v-if="object.third_party && object.third_party.name && isOwner(object.third_party)"
                  :to="{ name: 'contracts.view', params: { slug: object.third_party.slug, client: object.third_party.client }}"
                  qid="system-view-page-link"
              >
                {{object.third_party.name}}
              </router-link>

              <br style="height:0px;"/>
              <span class="text-muted" v-for="(vendor, index) in object.third_party.vendors">
                {{ vendor.name }}
                <span v-if="index < object.third_party.vendors.length - 1">, </span>
              </span>
            </td>
            <td>
              <span v-if="object.processing_role">
                <span v-if="object.processing_role == 'Data processor'">
                  <font-awesome-icon icon="microchip" class="mr-2"/>
                </span>
                <span v-if="object.processing_role == 'Data controller'">
                  <font-awesome-icon icon="joystick" class="mr-2"/>
                </span>
                <span v-if="object.processing_role == 'Joint controller'">
                  <font-awesome-icon icon="handshake" class="mr-2"/>
                </span>
                {{ $t('maintenance.third_parties.processing_role.' + $options.filters.slugify(object.processing_role)) }}
              </span>
            </td>
            <td>
              <span class="text-normal" v-if="object.third_party && object.third_party.type">
                <font-awesome-icon icon="shapes"/>
                {{ object.third_party.type }}
              </span>
            </td>
            <td>
              <span v-if="object.third_party.inspection" class="text-normal">
                {{ $t('maintenance.third_parties.inspection.' + $options.filters.slugify(object.third_party.inspection)) }}
              </span>
            </td>
            <td>
              <span v-if="object.third_party.data_processor_agreement" class="text-normal">
                {{ $t('maintenance.third_parties.data_processor_agreement.' + $options.filters.slugify(object.third_party.data_processor_agreement)) }}
              </span>
            </td>
            <td class="text-center">
              <span v-if="object.third_party.validation && object.third_party.validation.validation === 1">
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="object.third_party.validation && object.third_party.validation.validation === 0">
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
            </td>
            <td>
              <span class="text-normal">
                {{ object.updated_at | formatDate }}
              </span>
            </td>
            <td align="right">
              <span v-if="object.third_party"
                    @click="openViewTPModal(object)"
                    qid="tp-name-link"
                    class="btn btn-view"
              >
                <font-awesome-icon icon="eye"/>
              </span>

              <span class="btn btn-edit"
                    qid="edit-ac-modal"
                    @click="showEditTPModal(object)"
                    v-if="isGranted([permissions.SYSTEM_THIRD_PARTY_EDIT, permissions.SYSTEM_THIRD_PARTY_EDIT_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
              >
                <font-awesome-icon icon="pen"/>
              </span>
              <span class="btn btn-delete"
                    qid="delete-tp-modal"
                    v-if="isGranted([permissions.SYSTEM_THIRD_PARTY_DELETE, permissions.SYSTEM_THIRD_PARTY_DELETE_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
                    @click="showTPConfirmDeleteModal(object)"
              >
                <font-awesome-icon icon="trash-alt" />
              </span>
            </td>
          </tr>
          <tr v-if="!tpLoading && !tpTableItems.length" qid="no-results-row-tp" class="text-center">
            <td colspan="10">
              <h5 class="mt-3">
                {{ $t('system.no_results') }}
              </h5>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>


    <!-- Delete third party modal template -->
    <b-modal ref="delete-third-party" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-tp-title">
          {{ $t('systems.policies.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('systems.policies.delete.description') }}
        <span v-if="itemToDelete.third_party">{{ itemToDelete.third_party.name }}</span>
      </h5>
      <h5 class="text-center">
        {{ $t('systems.policies.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideTPConfirmDeleteModal"
                  qid="delete-policy-cancel-button"
        >
          {{ $t('systems.policies.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteTP(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-policy-submit-button"
                  v-if="isGranted([permissions.SYSTEM_THIRD_PARTY_DELETE, permissions.SYSTEM_THIRD_PARTY_DELETE_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
        >
          {{ $t('systems.policies.delete.submit') }}
        </b-button>
      </div>
    </b-modal>



    <!-- Add new third party -->
    <b-modal ref="add-third-party" hide-footer @hide="hideCreateTPModal">
      <div class="d-block text-center">
        <h4 qid="add-tp-title">
          {{ $t('systems.third_parties.create.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-tp-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="tpFormSubmit" qid="create-tp-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-ac-pg-label">
              {{ $t('activities.third_party.create.vendor_label') }}
            </label>
            <span class="text-red">*</span>
            <multiselect
                v-model="selectedVendor"
                :options="vendors"
                :placeholder="$t('activities.third_party.create.vendor_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                @search-change="loadVendors"
                track-by="slug"
                @select="reloadTP"
                @remove="reloadTPWithoutVendor"
                qid="create-ac-form-ac"
            >
              <template slot="option" slot-scope="props">
                <Avatar :object="props.option" size="xs"></Avatar>
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
              <template slot="singleLabel" slot-scope="props">
                <Avatar :object="props.option" size="xs"></Avatar>
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
            </multiselect>
          </b-form-group>
          <b-form-group v-if="selectedVendor && selectedVendor.id">
            <label qid="create-tp-item-label">
              {{ $t('systems.third_parties.create.tp_label') }}
            </label>
            <span class="text-red">*</span>
            <multiselect
                v-model="selectedTP"
                :options="tpItems"
                :placeholder="$t('systems.third_parties.create.tp_placeholder')"
                label="name"
                @search-change="loadTP"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                track-by="slug"
                qid="create-tp-form-tp"
            ></multiselect>
          </b-form-group>

          <div v-if="selectedTP && selectedTP.description"
               class="text-center mb-3 mt-4"
          >
            <span class="cursor-pointer">
              <span class="mr-2"
                    @click="showSDescription = !showSDescription"
                    qid="expand-tp-description"
              >
                {{$t('activities.third_party.create.third_party_description_expand')}}
              </span>
              <font-awesome-icon icon="chevron-down" v-if="!showSDescription"/>
              <font-awesome-icon icon="chevron-up" v-if="showSDescription"/>
            </span>
          </div>
          <div v-if="selectedTP && selectedTP.description && showSDescription" class="mb-4 mt-2">
            <span class="text-formatted">
              {{ selectedTP.description }}
            </span>
          </div>

          <b-form-group v-if="selectedVendor && selectedVendor.id">
            <label qid="create-tp-item-label">
              {{ $t('systems.third_parties.create.processing_role_label') }}
            </label>
            <span class="text-red">*</span>
            <multiselect
                v-model="processingRole"
                :options="processingRoleItems"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('systems.third_parties.create.processing_role_placeholder')"
                label="value"
                track-by="value"
                qid="create-tp-form-processing-role"
            >
              <template slot="option" slot-scope="props">
                <span v-if="props.option.value == 'Data processor'">
                  <font-awesome-icon icon="microchip" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Data controller'">
                  <font-awesome-icon icon="joystick" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Joint controller'">
                  <font-awesome-icon icon="handshake" class="mr-2"/>
                </span>
                {{ $t('maintenance.third_parties.processing_role.' + $options.filters.slugify(props.option.value)) }}
              </template>
              <template slot="singleLabel" slot-scope="props">
                <span v-if="props.option.value == 'Data processor'">
                  <font-awesome-icon icon="microchip" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Data controller'">
                  <font-awesome-icon icon="joystick" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Joint controller'">
                  <font-awesome-icon icon="handshake" class="mr-2"/>
                </span>
                {{ $t('maintenance.third_parties.processing_role.' + $options.filters.slugify(props.option.value)) }}
              </template>
            </multiselect>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideCreateTPModal"
                    qid="create-tp-cancel-button"
          >
            {{ $t('systems.third_parties.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    :disabled="buttonDisabled"
                    variant="success"
                    qid="create-tp-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('systems.third_parties.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- Edit third party modal -->
    <b-modal ref="edit-tp" hide-footer @hide="hideEditTPModal">
      <div class="d-block text-center">
        <h4 qid="add-tp-title">
          {{ $t('systems.third_parties.edit.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-tp-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="tpEditFormSubmit" qid="create-tp-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-tp-item-label">
              {{ $t('systems.third_parties.create.tp_label') }}
            </label>
            <br>
            <span v-if="selectedTP">
              {{selectedTP.name}}
            </span>
          </b-form-group>
          <b-form-group>
            <label qid="edit-tp-processing-role-label">
              {{ $t('systems.third_parties.create.processing_role_label') }}
            </label>
            <span class="text-red">*</span>
            <multiselect
                v-model="processingRole"
                :options="processingRoleItems"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('systems.third_parties.create.processing_role_placeholder')"
                label="text"
                track-by="value"
                qid="edit-tp-form-processing-role"
            >
              <template slot="option" slot-scope="props">
                <span v-if="props.option.value == 'Data processor'">
                  <font-awesome-icon icon="microchip" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Data controller'">
                  <font-awesome-icon icon="joystick" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Joint controller'">
                  <font-awesome-icon icon="handshake" class="mr-2"/>
                </span>
                {{ $t('maintenance.third_parties.processing_role.' + $options.filters.slugify(props.option.value)) }}
              </template>
              <template slot="singleLabel" slot-scope="props">
                <span v-if="props.option.value == 'Data processor'">
                  <font-awesome-icon icon="microchip" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Data controller'">
                  <font-awesome-icon icon="joystick" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Joint controller'">
                  <font-awesome-icon icon="handshake" class="mr-2"/>
                </span>
                {{ $t('maintenance.third_parties.processing_role.' + $options.filters.slugify(props.option.value)) }}
              </template>
            </multiselect>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditTPModal"
                    qid="create-tp-cancel-button"
          >
            {{ $t('systems.third_parties.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    :disabled="buttonDisabled"
                    variant="success"
                    qid="create-tp-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('systems.third_parties.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <ThirdPartyViewModal
        :object="selectedTP"
        :showModal="viewTPModal"
        @closeViewModal="handleCloseViewTPModal"
        :attachments="showAttachments"
    ></ThirdPartyViewModal>

    <VendorViewModal
        :object="vendorToView"
        :showModal="viewVendorModal"
        @closeViewModal="handleCloseViewVendorModal"
    ></VendorViewModal>

  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import roleCheck from "@/util/ACL/roleCheck"
  import Avatar from '@/components/Avatar.vue';
  import ThirdPartyViewModal from '@/views/Systems/ThirdPartyViewModal.vue';
  import UpdateSingleTaskModal from '@/views/Tasks/UpdateSingleTaskModal.vue';
  import VendorViewModal from '@/views/ThirdParty/VendorViewModal.vue';
  import GuideButton from '@/components/guide/GuideButton.vue';


  export default {
    name: 'ThirdPartiesTable',
    data: function() {
      return {

        tpForm: {
          processing_role: ''
        },

        // third parties
        tpTableItems: [],
        tpLoading: true,
        showTPDescription: false,
        tpItems: [],
        selectedTP: [],
        viewTPModal: false,
        processingRole: [],
        processingRoleItems: [
          { text: this.$t('maintenance.third_parties.processing_role.data_controller'), value: 'Data controller'},
          { text: this.$t('maintenance.third_parties.processing_role.data_processor'), value: 'Data processor'},
          { text: this.$t('activities.processing_role.joint_controller_label'), value: 'Joint controller' }
        ],
        showAttachments: false,
        system: {},
        selectedObject: {},
        vendors: [],
        selectedVendor: [],

        error: '',
        loadingItems: false,
        selectedDS: [],
        selectedDSSort: '',
        selectedDSDirection: '',
        acValidationShow: false,
        acTableItems: [],
        acLoading: true,
        dsItems: [],
        updateValidationList: false,
        itemToDelete: {},
        itemObject: {},
        reCertificationOptions: [],
        provisioningOptions: [],
        selectedRC: [],
        selectedP: [],
        validationOptions: [],
        validation: {},
        disabledValidationOptions: [],
        showDSDescription: false,
        buttonDisabled: false,
        selectedDataSubject: {},
        viewDataSubjectModal: false,
        myGuides: [],
        myTasks: [],
        showSDescription: false,
        vendorToView: {},
        viewVendorModal: false
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      },
      showOnTask: {},
      task: {}
    },
    components: {
      Avatar,
      ThirdPartyViewModal,
      UpdateSingleTaskModal,
      VendorViewModal,
      GuideButton
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
      getReloadTasks() {
        return this.$store.state.reloadTasks
      },
      getUser() {
        return this.$store.state.user
      },
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {

      },
      object: function (value) {
        if (value && value.slug) {
          this.system = value
          this.loadThirdParties();
          this.loadTasks('update_third_parties');
        }
      },
      getReloadContent: function () {
        if (!this.showOnTask) {
          if (this.$store.state.updatedObject && this.$store.state.updatedObject.id) {
            if (this.$store.state.updatedObject.id == this.system.id && this.$store.state.updatedObject.who_am_i == this.system.who_am_i) {
              this.system = this.$store.state.updatedObject
            }
          }
          this.reloadContent()
        }
      },
      getReloadTasks: function () {
        if (!this.showOnTask) {
          this.loadTasks('update_third_parties')
        }
      },
    },
    methods: {
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      reloadContent() {
        this.loadThirdParties();
        this.loadTasks('update_third_parties');
      },
      isOwner(object) {
        let self = this;
        let allow = false;
        let existingUser = _.find(object.users, function(user) {
          return user.id == self.getUser.id
        });

        if (existingUser) {
          allow = true
        } else {
          if (roleCheck('Client admin') || roleCheck('Partition admin') || roleCheck('Validator') || this.getUser.isAdmin) {
            allow = true
          }
        }

        return allow
      },
      loadTasks(code) {
        let self = this;
        if (this.getClient.projectModule) {
          piincHttp.get('projects/me/tasks', { params:
            {
              per_page: 1,
              status: 'pending',
              model_type: this.system.who_am_i,
              model_id: this.system.id,
              code: code,
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.myTasks = []
            if (response.data.items.length) {
              self.myTasks.push(response.data.items[0])
            }
          }, function() {});
        }
      },
      showEditTPModal(object) {
        this.selectedTP = object.third_party
        this.processingRole = _.find(this.processingRoleItems, function(item) {
          return item.value === object.processing_role;
        });

        this.selectedObject = object

        this.$refs['edit-tp'].show()
      },
      hideEditTPModal() {
        this.error = ''
        this.selectedTP = []
        this.processingRole = []
        this.loadContent()
        this.$refs['edit-tp'].hide()
      },
      tpEditFormSubmit(evt) {

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        if (this.selectedTP) {
          this.tpForm.third_party_id = this.selectedTP.id;
        }

        if (this.processingRole && this.processingRole.value) {
          this.tpForm.processing_role = this.processingRole.value
        } else {
          this.tpForm.processing_role = ''
        }

        if (this.processingRole && this.processingRole.value) {
          this.buttonDisabled = true;
          piincHttp.put('systems/' + this.system.slug + '/third-parties/' + this.selectedObject.id, this.tpForm).then(function() {
            self.hideEditTPModal();
            self.loadThirdParties();
            self.buttonDisabled = false;
            self.$toastr('success', self.$t('systems.third_parties.edit.success'))
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
              if (error.data.errors.third_party_id) {
                self.error += ' ' + error.data.errors.third_party_id[0]
              }
            }
          })
        } else {
          this.error = ''

          if (!this.processingRole || (this.processingRole && !this.processingRole.value)) {
            this.error +=  ' ' + this.$t('activities.third_party.create.processing_role_error')
          }

          this.buttonDisabled = false;
        }

      },
      openViewTPModal(object) {
        this.selectedTP = object
        this.viewTPModal = true
      },
      handleCloseViewTPModal () {
        this.selectedTP = []
        this.viewTPModal = false;
      },
      openViewVendorModal(object) {
        this.vendorToView = object
        this.viewVendorModal = true
      },
      handleCloseViewVendorModal () {
        this.vendorToView = []
        this.viewVendorModal = false;
      },
      navigateToTask(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        this.$router.push({ name: 'systems.view', params: { slug: object.model.slug }, query: { task: object.id }})
      },
      openToolbar(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'System' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'System',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      showCreateTPModal() {
        this.loadVendors();
        this.$refs['add-third-party'].show()
      },
      hideCreateTPModal() {
        this.error = ''
        this.selectedTP = [];
        this.selectedVendor = [];
        this.processingRole = [];
        this.$refs['add-third-party'].hide()
      },
      showTPConfirmDeleteModal(object) {
        this.itemToDelete = object
        this.$refs['delete-third-party'].show()
      },
      hideTPConfirmDeleteModal() {
        this.itemToDelete = {}
        this.$refs['delete-third-party'].hide()
      },
      loadContent() {
        let self = this;
        piincHttp.get('systems/' + this.system.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.system = response.data;
        }, function() {});
      },
      confirmDeleteTP(object) {
        let self = this;
        piincHttp.delete('systems/' + this.system.slug + '/third-parties/' + object.id).then(function() {
          self.hideTPConfirmDeleteModal();
          self.loadThirdParties();
          // Trigger toastr message after modal close
          self.$toastr('success', self.$t('systems.third_parties.delete.success'))
        }, function() {});
      },
      tpFormSubmit(evt) {

        let formData = new FormData();
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        if (this.selectedTP && this.selectedTP.id) {
          formData.append("third_party_id", this.selectedTP.id);
        }

        if (this.processingRole && this.processingRole.value) {
          formData.append("processing_role", this.processingRole.value);
        }

        formData.append("system", this.system.slug);


        if (this.processingRole && this.processingRole.value && this.selectedTP && this.selectedTP.id) {
          this.buttonDisabled = true;
          piincHttp.post('/systems/' + this.system.slug + '/third-parties', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function(response) {
            self.$toastr('success', self.$t('systems.third_parties.create.success'))
            self.hideCreateTPModal();
            self.buttonDisabled = false;
            self.loadThirdParties();
            self.loadContent();
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
              if (error.data.errors.third_party_id) {
                self.error += ' ' + error.data.errors.third_party_id[0]
              }
            }
          })
        } else {
          this.error = ''

          if (this.selectedVendor && this.selectedVendor.id) {
            if (!this.selectedTP || (this.selectedTP && !this.selectedTP.id)) {
              this.error +=  ' ' +  this.$t('activities.third_party.create.third_party_error')
            }
            if (!this.processingRole || (this.processingRole && !this.processingRole.value)) {
              this.error +=  ' ' + this.$t('activities.third_party.create.processing_role_error')
            }
          } else {
            this.error = this.$t('activities.third_party.create.vendor_error')
          }

          this.buttonDisabled = false;
        }
      },
      // Table list
      loadThirdParties() {
        let self = this;
        piincHttp.get('systems/' + this.system.slug + '/third-parties', { params:
          {
            client: this.getClient.slug,
          }
        }).then(function(response) {
          self.tpTableItems = response.data;
          self.tpLoading = false;
        }, function() {});
      },
      reloadTP(object) {
        this.selectedTP = []
        this.selectedVendor = object;
        this.loadTP()
      },
      reloadTPWithoutVendor(object) {
        this.selectedTP = []
        this.selectedVendor = [];
        this.loadTP()
      },
      loadTP(query) {
        let self = this;
        piincHttp.get('third-parties', { params:
          {
            activity: 1,
            client: this.getClient.slug,
            per_page: 100,
            vendor: this.selectedVendor && this.selectedVendor.id ? this.selectedVendor.id : null,
            relations: 1,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.tpItems = response.data.items
          if (self.tpItems && !self.tpItems.length && !query) {
            self.tpItems.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
          if (self.tpItems && self.tpItems.length == 1 && !query) {
            self.selectedTP = self.tpItems[0]
          }
        }, function() {});
      },
      loadVendors(query) {
        let self = this;
        piincHttp.get('vendors', { params:
          {
            client: this.getClient.slug,
            parent: this.getClient.parent ? 1 : undefined,
            has_contract: 1,
            per_page: 100,
            search: query ? query : undefined
          }
        }).then(function(response) {
          self.vendors = response.data.items
        }, function() {});
      },
    },
    created () {
      this.system = this.object;
      if (this.getClient && this.getClient.slug) {
        this.loadTP();
      }
      // Table items
      if (this.system && this.system.slug) {
        this.loadThirdParties();
        this.loadTasks('update_third_parties');
      }
      this.loadGuides('update_third_parties');
    }
  }
</script>
